module.exports = __webpack_public_path__ + "resources/img/img_experdb_jp_m.46faa37012884b93ce19b8cb5124da89.png";